module.exports = __webpack_public_path__ + "static/tilster-min-f608f95253cb50a4c9aaa6350a460cef.png";